import React from "react";
import { Check, Flame } from "lucide-react";

const Bar = ({ count, goal }) => (
  <div className="h-2.5 flex-1 rounded-full border-2 border-foreground bg-background overflow-hidden">
    <div
      className="h-full bg-primary transition-all duration-500"
      style={{ width: `${Math.min((count / goal) * 100, 100)}%` }}
    />
  </div>
);

export const MissionCard = ({ icon: Icon, title, subtitle, tasks, done, streak, doneLabel, testId }) => (
  <section className={`brutal-card p-5 mb-6 ${done ? "bg-accent" : "bg-card"}`} data-testid={testId}>
    <div className="flex items-center gap-2 mb-1">
      <Icon size={20} strokeWidth={2.5} />
      <h2 className="text-xl font-display">{title}</h2>
      {streak > 0 && (
        <span className="ml-auto brutal-btn px-2 py-1 text-xs font-bold bg-primary text-primary-foreground inline-flex items-center gap-1" data-testid={`${testId}-streak`}>
          <Flame size={12} strokeWidth={2.5} /> {streak}-day streak
        </span>
      )}
    </div>
    <p className="text-sm text-muted-foreground mb-4">{subtitle}</p>
    {done ? (
      <div className="flex items-center gap-2 font-semibold" data-testid={`${testId}-done`}>
        <span className="w-7 h-7 rounded-full border-2 border-foreground bg-foreground text-background flex items-center justify-center">
          <Check size={14} strokeWidth={3} />
        </span>
        {doneLabel}
      </div>
    ) : (
      <div className="space-y-2">
        {tasks.map((task) => (
          <div key={task.label} className="flex items-center gap-3">
            <span className="text-sm font-semibold w-40 shrink-0">{task.label}</span>
            <Bar count={task.count} goal={task.goal} />
            <span className="text-sm font-bold tabular-nums w-9 text-right">{task.count}/{task.goal}</span>
          </div>
        ))}
      </div>
    )}
  </section>
);
